import {RollPositionsInputs} from '../../adjustment-pricing-grid/copilot/apg-copilot-domain';
import {MavenSetupInputs} from '../maven-domain';
import {cloneMavenSetup, diffMavenSetup, MavenParamChangeMap} from '../setup/maven-setup-param-diff';
import {MavenTemplateIndicators, MavenTemplateSettings} from './maven-settings-template';
import {expandMavenIndicators, restoreMavenSide} from './maven-template-mapper';

/** Compare only the values a reusable template owns, using the existing field/money rules. */
export function diffMavenTemplate(template: MavenTemplateSettings | null, live: MavenSetupInputs,
    dates: RollPositionsInputs | null, allDates: MavenTemplateIndicators | null,
    dateKeys: string[], defaultQty: number | null): MavenParamChangeMap {
    if (!template || !dates) { return {}; }
    const baseline = cloneMavenSetup(live);
    baseline.existingHedges = template.existingHedges;
    baseline.calls = restoreMavenSide(template.calls);
    baseline.puts = restoreMavenSide(template.puts);
    // Fixed strikes remain run-only; range mode and distance are reusable and compared normally.
    baseline.calls.coverage.endStrike = live.calls.coverage.endStrike;
    baseline.puts.coverage.endStrike = live.puts.coverage.endStrike;
    baseline.dates.date = dates.date;
    baseline.dates.weekdayExclusions = dates.weekdayExclusions;
    const current = cloneMavenSetup(live);
    // An All Dates template specifies each date's values, so a one-date edit must also flag.
    // With no template override, only explicit All Dates preferences enter this comparison.
    // Keep a section-level cue even when no candidate dates are currently available.
    const keys = dateKeys.length ? dateKeys : ['all'];
    baseline.marketOverrides = expandMavenIndicators(template.allDatesOverride, keys);
    current.marketOverrides = template.allDatesOverride && dateKeys.length
        ? live.marketOverrides : expandMavenIndicators(allDates, keys);
    return diffMavenSetup(baseline, current, defaultQty);
}

export function mergeMavenChanges(run: MavenParamChangeMap, template: MavenParamChangeMap): MavenParamChangeMap {
    return {...run, ...template};
}
